export const elementaryPeriods = [
    {text:'一年级',grade:1101,period:1001},
    {text:'二年级',grade:1102,period:1001},
    {text:'三年级',grade:1103,period:1001},
    {text:'四年级',grade:1104,period:1001},
    {text:'五年级',grade:1105,period:1001},
    {text:'六年级',grade:1106,period:1001}
]
export const juniorPeriods = [
    {text:'初一',grade:1107,period:1003},
    {text:'初二',grade:1108,period:1003},
    {text:'初三',grade:1109,period:1003},
    {text:'高一',grade:1111,period:1005},
    {text:'高二',grade:1112,period:1005},
    {text:'高三',grade:1113,period:1005}
]
export const periods = [
    {text:'一年级',grade:1101,period:1001},
    {text:'二年级',grade:1102,period:1001},
    {text:'三年级',grade:1103,period:1001},
    {text:'四年级',grade:1104,period:1001},
    {text:'五年级',grade:1105,period:1001},
    {text:'六年级',grade:1106,period:1001},
    {text:'初一',grade:1107,period:1003},
    {text:'初二',grade:1108,period:1003},
    {text:'初三',grade:1109,period:1003},
    {text:'高一',grade:1111,period:1005},
    {text:'高二',grade:1112,period:1005},
    {text:'高三',grade:1113,period:1005}
]


// WEBPACK FOOTER //
// ./src/data/periods.js